import { Component, EventEmitter, OnInit, Output, effect, input, signal } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-countdown',
    templateUrl: './countdown.component.html',
    styleUrls: ['./countdown.component.scss'],
    standalone: true
})
export class CountdownComponent implements OnInit {
  public seconds = input<number>(0);
  public radius = input<number>();
  public size = input<number>();
  public roundTimeStart = input<Observable<Date>>();
  public events = input<Observable<boolean>>();

  @Output() timeExpired = new EventEmitter();

  public secondsTemp = signal(0);
  private PI = signal(0);
  private circumference = signal(0);
  private strokeDashArray = signal<string>('');
  private strokeDashOffset = signal<string>('0');
  private pie = signal(0);

  //private cancelled = signal(false);
  private elapsed = signal(0);
  public remaining = signal(0);

  private FIRST_THRESHOLD = signal(0);
  private SECOND_THRESHOLD = signal(0);
  private firstThreshold = signal(false);
  private secondThreshold = signal(false);
  private animated = signal(false);
  private countdownStopped: Subscription;

  private counterInt: number;
  private roundStarted: Subscription; 

  constructor() {
    effect(() => {
      this.secondsTemp.set(this.seconds());
    });
  }

  ngOnInit(): void {
    this.roundStarted = this.roundTimeStart().subscribe(date => {
      const started = this.convertTZ(date, 'Europe/Brussels').getTime();
      const now = new Date().getTime();
      
      this.elapsed.update(() => Math.round((now - started) / 1000));
    });

    this.FIRST_THRESHOLD.update(() => this.secondsTemp() / 2);
    this.SECOND_THRESHOLD.set(5);
    // this.firstThreshold = false;
    // this.secondThreshold = false;
    

    this.remaining.set(this.secondsTemp());

    // this.strokeDashOffset = '0';
    // this.cancelled = false;
    this.PI.update(() => 22/7);
    this.circumference.update(() => 2 * this.PI() * this.radius());
    this.pie.update(() => this.circumference() / this.secondsTemp());

    this.strokeDashArray.set(`${this.circumference()}px`);
    this.startCountdown();
    this.animated.set(true);

    this.countdownStopped = this.events().subscribe(() => this.stopCountdown());
  }

  private convertTZ(date: Date | string, timezone: string) {
    const convertToTz = new Date(date).toLocaleString("fr-Be", { 
      timeZone: timezone,
    }).replace(',', '').split(' ');

    const d = convertToTz[0].trim().split("/").reverse().map(e => +e);
    d[1] = d[1]-1;

    const t = convertToTz[1].trim().split(":").map(e => +e);
    const [year, month, day, hour, minute, second] = d.concat(t);

    return new Date(year, month, day, hour, minute, second); 
}

  private startCountdown() {
    if(this.remaining() <= this.FIRST_THRESHOLD()) {
      this.firstThreshold.set(true);
    }
    
    if(this.remaining() <= this.SECOND_THRESHOLD()) {
      this.firstThreshold.set(false);
      this.secondThreshold.set(true);
      // this.soundsService.playSound('countdown-timer');
    }
    
    this.counterInt = window.setTimeout(() => {
        this.strokeDashOffset.update(() => `${this.pie()*(this.elapsed() + 1)}px`);
        this.elapsed.update((e) => e + 1);
        this.remaining.update(() => this.secondsTemp() - this.elapsed());
        if(this.remaining() === 0) {
          this.secondsTemp.set(0);
          this.stopCountdown();
          this.timeExpired.emit();
        } else {
          this.startCountdown();
        }
        // window.requestAnimationFrame(counter);
    }, 1000);
  }

  public stopCountdown() {
    this.animated.set(false);
    this.firstThreshold.set(false);
    this.secondThreshold.set(false);

    window.clearTimeout(this.counterInt);
    // this.soundsService.stopSound();
  }

  public formatTime(seconds: number) {
    let min: number | string = parseInt((seconds / 60).toString());
    min = min < 10 ? "0" + min : min;

    let sec: number | string = seconds % 60;
    sec = sec < 10 ? "0" + sec : sec;

    return [min, sec].join(':');
  }

  ngOnDestroy() {
    this.countdownStopped?.unsubscribe();
    this.roundStarted?.unsubscribe();
    // this.soundsService.stopSound();
  }
}
